<template>
  <div class="container">
    <el-form
      class="form-header"
      ref="formAdStatistic"
      label-position="top"
      :model="formAdStatistic">
      <el-form-item label="所属端" prop="adsensePlatform">
        <el-select v-model="formAdStatistic.adsensePlatform" placeholder="请选择" @change="initAdManagerDtos">
          <el-option label="全部" value="全部"></el-option>
          <el-option
            v-for="item in platformList"
            :key="item.Value"
            :label="item.Name"
            :value="item.Value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="位置" prop="type">
        <el-select v-model="formAdStatistic.type" placeholder="请选择">
          <el-option
            v-if="formAdStatistic.adsensePlatform == '全部'"
            label="全部"
            value="全部">
          </el-option>
          <el-option
            v-for="(item,index) in managerDtos"
            :key="index"
            :label="item.Name"
            :value="item.AdsenseType">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="标题" prop="title">
        <el-input v-model="formAdStatistic.title" placeholder="广告位标题关键字"></el-input>
      </el-form-item>
      <el-form-item label="时间范围" prop="timeRange">
        <el-date-picker
          v-model="formAdStatistic.timeRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          @change="timeChange">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="删除状态" prop="isDelete">
        <el-select v-model="formAdStatistic.isDelete" placeholder="请选择">
          <el-option label="全部" value="全部"></el-option>
          <el-option label="正常" value="false"></el-option>
          <el-option label="已删除" value="true"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="btn-box">
        <el-button type="primary" icon="el-icon-search" @click="handleCurrentChange(1)">筛选</el-button>
        <el-button @click="resetFn('formAdStatistic')">重置</el-button>
        <el-button icon="el-icon-download" @click="exportFn">导出</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      @sort-change="handleSortChange"
      style="width: 100%">
      <el-table-column prop="Id" label="广告位ID"></el-table-column>
      <el-table-column prop="Platform" label="所属端">
        <template slot-scope="scope">
          {{ platformList.find(item => item.Value === scope.row.Platform)?.Name || '-'}}
        </template>
      </el-table-column>
      <el-table-column prop="Location" label="位置"></el-table-column>
      <el-table-column prop="Name" label="广告位标题"></el-table-column>
      <el-table-column prop="ImgURL" label="缩略图">
        <template slot-scope="scope">
          <el-image
            style="width: 100px; height: 100px"
            :src="scope.row.ImgURL" 
            :preview-src-list="[scope.row.ImgURL]">
          </el-image>
        </template>
      </el-table-column>
      <el-table-column prop="PvCount" label="曝光PV" sortable="custom"></el-table-column>
      <el-table-column prop="UvCount" label="曝光UV" sortable="custom"></el-table-column>
      <el-table-column prop="PvClickCount" label="点击PV" sortable="custom"></el-table-column>
      <el-table-column prop="UvClickCount" label="点击UV" sortable="custom"></el-table-column>
      <el-table-column prop="deleteStatus" label="是否已删除">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.IsDelete" type="info">已删除</el-tag>
            <el-tag v-else type="success">正常</el-tag>
          </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next,sizes,jumper,total"
      :page-sizes="[10, 20, 30, 40, 50, 60]"
      :current-page="pagin.pageIndex"
      :page-size="pagin.pageSize"
      :total="pagin.TotalNumber"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      style="margin-top:20px;">
    </el-pagination>
  </div>
</template>

<script>
import down from "../../js/down";
export default {
  components: {
  },
  data(){
    return {
      platformList:[], // 所属平台
      managerDtos:[], // 平台列表
      formAdStatistic:{
        adsensePlatform:'全部', // 所属端
        type:'全部', // 位置
        title: '', // 标题
        startTime:'', // 开始时间
        endTime:'', // 结束时间
        isDelete:'全部', // 删除状态
        timeRange:'',
        orderType:0, // 0 默认,1 uv正序,2 uv倒序, 3 pv正序, 4 pv倒序, 5 pv点击正序,6 pv点击倒序,7 uv点击正序,8 uv点击倒序
      },
      tableData:[],
      pagin:{
        pageIndex:1,
        pageSize:10,
        TotalNumber:0
      }
    }
  },
  created(){
    this.initAdPlatform();
    // this.initAdManagerDtos('全部');
    this.initList();
  },
  mounted(){
  },
  methods:{
    // 获取广告位平台列表
    initAdPlatform() {
      this.$get(this.$api.GetAdsensePlatforms).then(res=>{
        this.platformList = res;
      })
    },
    // 获取广告位列表
    initAdManagerDtos(val) {
      if(val == '全部') {
        val = '';
        this.formAdStatistic.type = '全部';
        this.managerDtos = [];
        return
      } else {
        val = val;
        this.formAdStatistic.type = '';
      }
      this.$get(this.$api.GetAdsenseManagerDtos,{
        adsensePlatform:val=='全部'?'':val
      }).then(res=>{
        this.managerDtos = res;
      })
    },
    // 日期范围
    timeChange(val) {
      if(val) {
        this.formAdStatistic.startTime=val[0];
        this.formAdStatistic.endTime=val[1];
      } else {
        this.formAdStatistic.startTime='';
        this.formAdStatistic.endTime='';
      }
    },
    // 获取列表
    initList() {
      let data=JSON.parse(JSON.stringify(this.formAdStatistic));
      data.adsensePlatform = data.adsensePlatform == '全部'?'':data.adsensePlatform;
      data.type = data.type == '全部'?'':data.type;
      data.isDelete = data.isDelete == '全部'?'':data.isDelete;
      this.$post(this.$api.GetAppAdsensesStatic,{},{...this.pagin,...data}).then(res=>{
        this.tableData = res.Data;
        this.pagin.TotalNumber = res.TotalNumber;
      })
    },
    // 每页多少条
    handleSizeChange(val) {
      this.pagin.pageSize = val;
      this.initList();
    },
    // 当前页
    handleCurrentChange(val) {
      this.pagin.pageIndex = val;
      this.initList();
    },
    // 重置
    resetFn(formName) {
      this.formAdStatistic = {
        adsensePlatform:'全部', // 所属端
        type:'全部', // 位置
        title: '', // 标题
        startTime:'', // 开始时间
        endTime:'', // 结束时间
        isDelete:'全部', // 删除状态
        timeRange:'',
        orderType:0, // 0 默认,1 uv正序,2 uv倒序, 3 pv正序, 4 pv倒序
      }
      this.managerDtos = [];
      this.$refs[formName].resetFields();
      this.initList();
    },
    // 导出
    async exportFn() {
      let data=JSON.parse(JSON.stringify(this.formAdStatistic));
      data.adsensePlatform = data.adsensePlatform == '全部'?'':data.adsensePlatform;
      data.type = data.type == '全部'?'':data.type;
      data.isDelete = data.isDelete == '全部'?'':data.isDelete;

      const res = await this.$download(this.$api.ExportAdSenseStatistics, {},data);

      down.downloadExcel(res,'广告统计数据导出');
    },
    // 排序
    handleSortChange({ column, prop, order }) {
      // ascending升序,正序
      if(prop == 'UvCount' && order == 'ascending') {
        this.formAdStatistic.orderType = 1;
      } else if(prop == 'UvCount' && order == 'descending') {
        this.formAdStatistic.orderType = 2;
      } else if(prop == 'PvCount' && order == 'ascending') {
        this.formAdStatistic.orderType = 3;
      } else if(prop == 'PvCount' && order == 'descending') {
        this.formAdStatistic.orderType = 4;
      } else if(prop == 'PvClickCount' && order == 'ascending') {
        this.formAdStatistic.orderType = 5;
      } else if(prop == 'PvClickCount' && order == 'descending') {
        this.formAdStatistic.orderType = 6;
      } else if(prop == 'UvClickCount' && order == 'ascending') {
        this.formAdStatistic.orderType = 7;
      } else if(prop == 'UvClickCount' && order == 'descending') {
        this.formAdStatistic.orderType = 8;
      } else {
        this.formAdStatistic.orderType = 0;
      }
      this.initList();
    }
  
  }
};
</script>

<style lang="stylus" scoped>
.container {
  background: #fff;
  padding: 10px 10px;
  border-radius: 10px;
}
.form-header {
  display: flex;
  flex-wrap: wrap;
  align-items:flex-end;
  .el-form-item {
    margin-right: 20px;
  }
  .btn-box {
    display: flex;
  }
}
/deep/.el-date-editor .el-range-separator {
  padding: 0;
}
</style>